// Indeksy głównych zakładek portalu (kolejność wyświetlania: najemcy, mieszkania)
export const TAB_TENANTS = 0;
export const TAB_PROPERTIES = 1;

// Początkowa zakładka na podstawie URL:
// ?mieszkania lub /m/... -> mieszkania, w pozostałych przypadkach (w tym ?najemcy, /n/...) -> najemcy
export const getInitialTab = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.has('mieszkania') || window.location.pathname.startsWith('/m/')) {
    return TAB_PROPERTIES;
  }
  return TAB_TENANTS;
};
